import { connectSearchBox } from 'react-instantsearch-dom';

const SearchBox = ({ currentRefinement, isSearchStalled, refine, translations }) => {

  return (
    <form noValidate action="" role="search" className="space-y-4">
      <input
        className="border rounded border-input-border dark:border-dark-input-border w-full dark:text-white dark:bg-theme-dark-light"
        type="search"
        value={currentRefinement}
        onChange={event => refine(event.currentTarget.value)}
        placeholder={translations.placeholder}
      />
      {/* {currentRefinement ?
        <button onClick={() => refine('')} className="bg-highlight-yellow py-2 text-center rounded w-full">Limpiar Busqueda</button>
        :
        null
      } */}
    </form >
  );
};

const CustomSearchBox = connectSearchBox(SearchBox);

export default CustomSearchBox;